import {observer} from "mobx-react-lite";
import React, {useEffect, useRef} from "react";
import {MrFirstVideo} from "../../utils/mrFirst";
import "./style.scss";

const MrFirst = observer(() => {
    let getThreeRef = useRef(null);
    let canvasRef = useRef(null);

    useEffect(() => {
        getThreeRef.current = new MrFirstVideo();
        getThreeRef.current.execute(canvasRef);

        return () => {
            getThreeRef.current.cleanupListener();
        };
    }, []);

    return (
        <>
            <div className={`mr_first`}>
                <canvas id={"canvas_mr_first"} ref={el => canvasRef = el}></canvas>
            </div>
        </>
    );
});

export default MrFirst;
